import React, {useContext} from 'react';
import { SessionContext, initialState } from '../../Session';
import HeaderButton from "../../../components/HeaderButton";
import Logo from '../../../images/10 Fitness Logo.png';

function HeaderSection() {
    const { dispatch, session } = useContext(SessionContext) || { session: initialState }
    let exitHref = "/"
    if (session.clubNumber === "FORM") {
        exitHref = "https://10fitness.com/your-10-fitness-account/"
    }
    return (
        <section className="section">
            <div className="container">
                <div className="columns">
                    <div className="column is-one-third">
                        <img src={Logo} style={{height: '80px'}} alt="gatsby-logo" />
                    </div>
                    <div className="column is-one-third">
                    </div>
                    <div className="column is-one-third">
                        <HeaderButton to={exitHref} onClick={()=>{dispatch({
                            type: 'LOGOUT'
                        })}}>
                            exit
                        </HeaderButton>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeaderSection;